<div class="page-content">
    <div class="page-header">
        <h1>Mes temps</h1>
        <div class="page-description">
                {{range?.from?.toLocaleDateString()}} - {{range?.to?.toLocaleDateString()}}
             </div>
    </div>

    <div class="page-body">
        <div class="row g-3">
            <div class="col-sm-12 col-md-3">
                <ed-button 
                    (click)="onClickPreviousTimesheet()"
                    [colorSchema]="ButtonColors.Dark"
                >
                Précédent</ed-button>
            </div>
            <div class="col-sm-12 offset-md-6 col-md-3">
                <ed-button 
                    (click)="onClickNextTimesheet()"
                    [colorSchema]="ButtonColors.Dark"
                    >
                    Suivant</ed-button>
            </div>
        </div>
        <br/>

        <timesheet-grid-card
            [timesheets]="timesheets"
            [projects]="projects"
            [isLoading]="timesheets.length == 0 || projects.length == 0"
            [canEdit]="canEdit"
            (onSearchProject)="onSearchProject($event)"
            (save)="save($event)"
            (onEdit)="onEdit($event)"
        ></timesheet-grid-card>
      

        @if(isCompleted()){
            <span><label>Vous ne pouvez pas éditer cette feuille</label></span>
        }
    </div>
           
</div>
<ed-alert></ed-alert>